import '../commons/styles/footer.scss'
import App from "./ServiceRepair.vue"
import CommonHeader from '../commons/components/CommonHeader'
import CommonFooter from '../commons/components/CommonFooter'
import QrCodes from '../commons/components/QrCodes.vue'
import request from '../commons/utils/request'
import loginPlugin from '../commons/plugins/loginPlugin'
Vue.use(loginPlugin)
Vue.prototype.$request = request
Vue.config.productionTip = false
new Vue({
  render: (h) => h(App),
}).$mount("#app")
new Vue({
  render: h => h(CommonHeader, {
    props: {
      active: 'serviceindex'
    }
  }),
}).$mount('#header')

new Vue({
  render: h => h(CommonFooter)
}).$mount('#footerCommon')

new Vue({
  render: h => h(QrCodes)
}).$mount('#qrCodes')


